import * as React from 'react'

import { Box, Href, Icon, Text } from '@factorialco/deprecated-design-system'
import { AnswerFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { joinAsSentence } from 'modules/core/lib/stringUtils'

import { answerHasNoResponse, getMultipleChoiceValue } from 'modules/ats/lib/utils/customQuestion'

interface Props {
  answer: AnswerFragment
  isLastItem: boolean
}

export const AtsAnswerCard = ({ answer, isLastItem }: Props) => {
  return (
    <Box
      gap="s4"
      width="full"
      paddingY="s12"
      paddingX="s12"
      border={
        isLastItem
          ? undefined
          : {
              bottom: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }
      }
    >
      <Text.Normal size="200" color="textPrimary" weight="medium">
        {answer.originalQuestionLabel}
      </Text.Normal>

      <AnswerValue answer={answer} />
    </Box>
  )
}

function AnswerValue({ answer }: Pick<Props, 'answer'>) {
  if (answerHasNoResponse(answer)) {
    return (
      <Text.Normal size="200" color="textSecondary">
        {i18n.t('ats.answers.no_response')}
      </Text.Normal>
    )
  }

  if (answer.originalQuestionType === 'multiple_choice') {
    const responses = getMultipleChoiceValue(answer)
    return (
      <Text.Normal size="200" color="textSecondary">
        {joinAsSentence(responses)}
      </Text.Normal>
    )
  }

  if (answer.originalQuestionType === 'file') {
    return (
      <Box gap="s8">
        {answer.files.map((file) => (
          <Href key={file.id} href={file.url} target="_blank" download={file.filename}>
            <Box
              flexDirection="row"
              alignItems="center"
              justifyContent="spaceBetween"
              gap="s16"
              borderRadius={{ all: 'abs008' }}
              border={{
                all: {
                  width: 's1',
                  style: 'solid',
                  color: 'grey400',
                },
              }}
              paddingX="s24"
              paddingY="s16"
            >
              <Text.Normal size="200" color="textSecondary" ellipsis>
                {file.filename}
              </Text.Normal>
              <Icon.Medium icon="download" color="grey1000" />
            </Box>
          </Href>
        ))}
      </Box>
    )
  }

  return (
    <Text.Normal size="200" color="textSecondary">
      {answer.value}
    </Text.Normal>
  )
}
